<template>
  <div>
    <v-text-field
      :readonly="readonly"
      :class="classes"
      :placeholder="placeholder"
      :type="type"
      :name="name"
      v-model="inputVal"
      :autocapitalize="autocapitalize"
      :counter="counter"
      v-validate="validation"
      :error-messages="errorMessages && errors.first(name) ? errorMessages : errors.first(name) "
      :disabled="disabled"
      :autofocus="autofocus"
      :hide-details="hideDetails"
      @focus="focusField()"
      @blur="showApendIcon = false"
      :append-icon="showApendIcon && $vuetify.breakpoint.xsOnly ? icon : ''"
      @click:append="blurField()"
      ref="input"
    >
      <template v-slot:append>
        <slot name="appendedSlot" />
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import { Validator } from 'vee-validate';
export default {
  props: ['placeholder', 'type', 'name', 'value', 'autocapitalize', 'counter', 'validation', 'classes', 'errorMessages', 'icon', 'disabled', 'autofocus', 'hideDetails', 'readonly'],
  components: { VTextField },
  data() {
    return {
      inputVal: this.value,
      showApendIcon: false
    };
  },
  watch: {
    inputVal(newValue){
      this.$emit('input', newValue.trim());
    },
    value(newValue, oldValue){
      if (oldValue != newValue){
        this.inputVal = newValue;
      }
    }
  },
  methods: {
    blurField() {
      this.$refs.input.blur();
      this.showApendIcon = false;
    },
    focusField(){
      this.showApendIcon = true;
    },
    validateEmoji(value) {
      // this is regex for emoji detection. https://stackoverflow.com/questions/10992921/how-to-remove-emoji-code-using-javascript
      if (
        !value.match(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
        )
      ) {
        return true;
      }
      return false;
    }
  },
  created(){
    //first setting the value of input
    this.inputVal = this.value;

    Validator.extend('emojiValidation', {
      getMessage: () =>
        this.$t('message.bizgainOnboarding.specialCharacterValidation'),
      validate: (value) => {
        return this.validateEmoji(value);
      }
    });
  }
};
</script>